exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-templates-receipt-style__header{padding-top:100px;text-align:center;font-size:30px}.nil-sa-templates-receipt-style__header i{font-size:40px}.nil-sa-templates-receipt-style__body{padding-top:50px;text-align:center;font-size:20px}.nil-sa-templates-receipt-style__footer{text-align:center;margin-top:80px;font-size:20px}div.nil-sa-templates-receipt-style__link{display:inline-block;color:#388efb;cursor:pointer;padding:0 20px}", ""]);

// exports
exports.locals = {
	"header": "nil-sa-templates-receipt-style__header",
	"body": "nil-sa-templates-receipt-style__body",
	"footer": "nil-sa-templates-receipt-style__footer",
	"link": "nil-sa-templates-receipt-style__link"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/templates/Receipt/style.less
// module id = 349
// module chunks = 0